import { useQuery, UseQueryResult } from '@tanstack/react-query'
import {
  queryCacheOptions,
  reportingQueryKeys,
} from 'src/queries/queries.constants'
import { fetchSpendChart } from 'src/queries/reporting/network/reporting.network'
import {
  SpendChartRequestParams,
  SpendChartResponse,
} from 'src/queries/reporting/reporting.models'

export const useQuerySpendChart = (
  params: SpendChartRequestParams,
  enabled = true,
): UseQueryResult<SpendChartResponse> =>
  useQuery({
    queryKey: reportingQueryKeys.spendChart(params),
    queryFn: () => fetchSpendChart(params),
    enabled:
      enabled &&
      params.organizationId !== undefined &&
      params.since !== '' &&
      params.until !== '' &&
      params.currency !== undefined,
    ...queryCacheOptions(),
  })
